
@switch (isObjectArrayProperty(property.propertyType)) {
  @case (true) {
    @for (prop of property.propertyType; track prop; let i = $index) {
      <entity-property [property]="prop" [predicate]="property.propertyName" [index]="i" (propertyAdded)="modelCreated($event)"></entity-property>
    }
  }
  @case (false) {
    <div class="grid-x border-bottom" [formGroup]="form">
      <div class="cell small-6 shrink-font">
        <span class="padding-right">
          <button (click)="addProperty(property.propertyName)">
            <svg-icon icon="icon-plus" class="tiny black"></svg-icon>
          </button>
        </span>
        {{property.propertyName}}
      </div>
      <div class="cell small-3">
        <div class="checkbox">
          <input class="show-for-sr" type="checkbox" [attr.id]="index + '_' + predicate + '_require'" formControlName="require" />
          <label [attr.for]="index + '_' + predicate + '_require'">
            <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span><span class="shrink-font"> Required</span>
          </label>
        </div>
      </div>
      <div class="cell small-3">
        <div class="checkbox">
          <input class="show-for-sr" type="checkbox" [attr.id]="index + '_' + predicate + '_api'" formControlName="api" />
          <label [attr.for]="index + '_' + predicate + '_api'">
            <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span><span class="shrink-font"> API Format</span>
          </label>
        </div>
      </div>
    </div>
  }
}
